import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {ContainerService, StoreSelectorsService} from "../../../services";
import {MatTableDataSource} from "@angular/material/table";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {BlockBaseComponent} from "../scene-blocks/block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {MapInfoWindow} from "@angular/google-maps";
import {IAppStatic, IPager, IStationStatsV1, IUser} from "../../../interfaces";
import {isNullOrUndefined} from "util";
import {actionLoadStationRequest, actionSceneItemLocationCoords, actionSelectedSceneItemId} from "../../../store/actions/user.actions";
import {TranslocoService} from "@ngneat/transloco";
import { HttpClient } from '@angular/common/http';
import {catchError, filter, map} from 'rxjs/operators';
import {appData} from "../../../common";
import {of} from 'rxjs';
import * as _ from 'lodash';
import {Lib} from "../../../../libs/Lib";

// import {SelectionModel} from "@angular/cdk/collections";

declare let jQuery: any;

@Component({
    selector: 'app-location-based',
    templateUrl: './location-based.component.html',
    styleUrls: ['./location-based.component.scss']
})
export class LocationBasedComponent extends BlockBaseComponent implements OnInit, AfterViewInit {
    lat: any = 51.673858;
    lng: any = 7.815982;
    center = {lat: 38, lng: -103};
    inSimMode = false;
    m_inRange = false;
    m_simStatus = 'status: waiting...';
    m_simulatedLat = 0;
    m_simulatedLng = 0;
    m_simUrl = '';
    contGroup: FormGroup;
    filter = '';
    appStatic: IAppStatic;
    stations: IStationStatsV1[];
    user: IUser;
    dataSource: MatTableDataSource<any>;
    displayedColumns: string[] = ['select', 'status', 'name', 'startTime', 'lastUpdate', 'IP', 'appVersion', 'totalMemory'];
    // selection: SelectionModel<number>;
    markerPositions = [];
    zoom = 10;
    display?: google.maps.LatLngLiteral;
    googleMapApiLoaded = false;

    @ViewChild(MapInfoWindow, {static: false}) googleMaps: MapInfoWindow;
    @ViewChild('address') address;

    @Input() propsMinimized = false;

    @Output() toggleMinimize: EventEmitter<any> = new EventEmitter<any>();
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();
    
    constructor(private containerService: ContainerService, private zone: NgZone, private cd: ChangeDetectorRef,
                private fb: FormBuilder, private toastr: ToastrService,
                private translocoService: TranslocoService, private httpClient: HttpClient,
                public override dialog: MatDialog, private storeSelectorsService: StoreSelectorsService) {
        super(storeSelectorsService, dialog);
        this.contGroup = fb.group({
            'stations': [],
            'port': ['9999'],
            'postMode': []
        });
        this.cod(
            this.storeSelectorsService.getAppSettings().subscribe((s) => {
                this.appStatic = s;
            })
        );
        this.cod(
            this.storeSelectorsService.getStationStats().subscribe((s) => {
                this.stations = s;
            })
        );
        this.cod(
            this.storeSelectorsService.getUser().subscribe((u) => {
                this.user = u;
            })
        );
        this.cod(
            this.storeSelectorsService.listenSelectedSceneLocationIndex()
                .pipe(filter((v) => v !== null))
                .subscribe(([p]) => {
                    if (!this.sceneItem?.Data[0]?.LocationBased || !this.sceneItem?.Data[0]?.LocationBased[0]?.GPS[0]?.Page) {
                        return;
                    }
                    const page: IPager = this.sceneItem?.Data[0]?.LocationBased[0]?.GPS[0]?.Page[p];
                    if (page) this.setCenter(page.$.lat, page.$.lng);
                })
        );

        if (!window.google || !window.google.maps || Object.keys(window.google.maps).length == 0) {
            this.cod(
                this.httpClient.jsonp(appData.googleMapUrl, 'callback')
                .pipe(
                    map(() => true),
                    catchError(() => of(false))
                ).subscribe((res) => {
                    this.googleMapApiLoaded = res;
                    if (!res) {
                        console.error("google map api is not connected!");
                    } else {
                        this.initAutoComplete();
                    }
                })
            );
        } else {
            this.googleMapApiLoaded = true;
        }
    }

    override componentInit() {
        super.componentInit();
        console.log('location based init: ' + this.sceneItem.$.id);
    }

    public override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.updateLocations();
    }

    onBackScene() {
        this.storeSelectorsService.dispatch(actionSceneItemLocationCoords({indexes: null}));
        this.storeSelector.dispatch(actionSelectedSceneItemId({id: this.sceneId}));
        this.containerService.updateEditorMode(null);
    }

    private updateLocations() {
        if (!this.sceneItem.Data[0]?.LocationBased) {
            this.onBackScene();
            return;
        }
        if (!this.sceneItem.Data[0]?.LocationBased[0]?.GPS || !_.isArray(this.sceneItem.Data[0]?.LocationBased[0]?.GPS[0]?.Page)) return;
        this.markerPositions = [];
        const pages = _.cloneDeep(this.sceneItem.Data[0].LocationBased[0].GPS[0].Page);
        pages.forEach((i_pager) => {
            if (!i_pager.$.lat || !i_pager.$.lng || i_pager.$.lat === '0' || i_pager.$.lng === '0') return;
            if (!i_pager.$.radios) i_pager.$.radios = '5';
            if (!i_pager.$.priority) i_pager.$.priority = '1';
            this.markerPositions.push({
                instance: i_pager,
                id: _.uniqueId('__'),
                name: i_pager.$.page,
                lat: Number(i_pager.$.lat),
                lng: Number(i_pager.$.lng),
                radius: Number(i_pager.$.radios) * 1000,
                label: '',
                draggable: false
            });
        });
        this.forceUpdateUi();
    }

    removeLastMarker() {
    }

    move(event: google.maps.MapMouseEvent) {
        this.display = event.latLng.toJSON();
    }

    ngAfterViewInit() {
        this.initAutoComplete();
    }

    initAutoComplete() {
        if (!this.googleMapApiLoaded) return;

        console.log('google script loaded');
        const autocomplete = new google.maps.places.Autocomplete(this.address.nativeElement, {});
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            this.zone.run(() => {
                /*
                 "Zone.run" allows the map to be immediately updated.
                 Without it, you would have to click the map to observe
                 the new lat and lng
                 */
                const place = autocomplete.getPlace();
                if (!place || !place.geometry) return;
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                this.setCenter(lat, lng);
            });
        });
    }

    _toggleSimMode() {
        this.inSimMode = !this.inSimMode;
        if (!this.inSimMode) {
            this.m_simulatedLat = 0;
            this.m_simulatedLng = 0;
            this.m_inRange = false;
        } else {
            this._loadStationList();
            this.contGroup.controls.postMode.setValue('local');
        }
        this.forceUpdateUi();
    }

    _loadStationList() {
        this.storeSelector.dispatch(actionLoadStationRequest({businessId: this.user.businessId}));
    }

    _onStationSelected(event) {
    }

    private _simulateEvent(i_marker, i_inRange) {
        this.m_inRange = i_inRange;
        this.m_simulatedLat = i_marker.lat;
        this.m_simulatedLng = i_marker.lng;
        const selected = this.contGroup.value.stations;
        if (_.isNull(selected) || _.isEmpty(selected)) return this.toastr.error(this.translocoService.translate('general.noPlayerSelected', {}, this.translocoService.getActiveLang()));
        const postMode = this.contGroup.value.postMode;
        const id = this.contGroup.value.stations.$.id;
        const ip = postMode === 'local' ? this.contGroup.value.stations.$.localAddress : this.contGroup.value.stations.$.publicIp;
        if (!ip) return this.toastr.error(this.translocoService.translate('general.noIpFound', {}, this.translocoService.getActiveLang()));
        const port = this.contGroup.value.port;
        const msg = (postMode == 'local') ? this.translocoService.translate('general.clickToSendPost', {}, this.translocoService.getActiveLang()) : this.translocoService.translate('general.sendingPost', {}, this.translocoService.getActiveLang());
        this.toastr.info(msg);
        const url = this.sendLocalEventGPS(postMode, this.m_simulatedLat, this.m_simulatedLng, id, ip, port, (e) => {
            this.m_simStatus = msg;
            this.m_simUrl = url;
            this.cd.markForCheck();
        });
        this.cd.markForCheck();
    }

    sendLocalEventGPS(i_mode, i_lat, i_lng, i_id, i_ip, i_port, i_callBack) {
        // example posts
        // curl "http://192.168.92.133:1024/sendLocalEvent?eventName=gps&eventParam=34.22447,-118.828"
        let url;
        let returnUrl;
        if (i_mode == "local") {
            url = 'http://' + i_ip + ':' + i_port + '/sendLocalEvent?eventName=gps&eventParam=' + i_lat + ',' + i_lng;
            this.m_simUrl = url;
            returnUrl = url;
        } else {
            url = `${this.appStatic.protocol}${this.user.businessDomain}/WebService/sendCommand.ashx?i_user=${this.user.name}&i_password=${Lib.Base64().encode(this.user.passwordNew)}&base64=1&i_stationId=${i_id}&i_command=event&i_param1=gps&i_param2=${i_lat},${i_lng}&callback=?`;
            returnUrl = `//remoteServer&i_stationId=${i_id}&i_command=event&i_param1=gps&i_param2=${i_lat},${i_lng}`;
        }
        if (i_mode == 'local')
            return returnUrl;
        try {
            jQuery.ajax({
                url,
                dataType: "jsonp",
                type: "post",
                complete(response) {
                    if (i_callBack)
                        i_callBack(response.statusText);
                },
                error(jqXHR, exception) {
                    console.log(jqXHR, exception);
                    if (i_callBack)
                        i_callBack(exception);
                }
            });
        } catch (e) {
            console.log('error on ajax' + e);
        }
        return returnUrl;
    }

    _openSimUrl(e) {
        if (this.contGroup.value.postMode != 'local') return;
        const id = this.contGroup.value.stations.$.id;
        const ip = this.contGroup.value.postMode === 'local' ? this.contGroup.value.stations.$.localAddress : this.contGroup.value.stations.$.publicIp;
        const port = this.contGroup.value.port;
        const url = this.sendLocalEventGPS('local', this.m_simulatedLat, this.m_simulatedLng, id, ip, port, (e2) => {
        });
        window.open(url, '_blank');
    }

    clickedMarker(i_marker, index: number, $event) {
        this.mapClicked($event);
        if (this.inSimMode)
            return this._simulateEvent(i_marker, true);
        
    }

    mapClicked($event) {
        this.m_simulatedLat = $event['latLng'].lat();
        this.m_simulatedLng = $event['latLng'].lng();
        const marker = {
            id: Math.random(),
            radius: 10000,
            lat: this.m_simulatedLat,
            lng: this.m_simulatedLng,
            draggable: true,
            new: true
        };
        this.storeSelectorsService.dispatch(actionSceneItemLocationCoords({indexes: [this.m_simulatedLat, this.m_simulatedLng]}));
        this.forceUpdateUi();
        if (this.inSimMode) return this._simulateEvent(marker, false);
    }

    public forceUpdateUi() {
        this.cd.reattach();
        setTimeout(() => {
            this.cd.detach();
        }, 1000);
    }

    public setCenter(lat, lng) {
        if (isNullOrUndefined((lat)) || lat === 0) lat = 34;
        if (isNullOrUndefined((lng)) || lng === 0) lng = -118;
        lat = +lat;
        lng = +lng;
        this.center = {lat, lng};
        this.forceUpdateUi();
    }
}





